module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "to": "reports/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Report")]), _vm._v(" "), _c('table-list', {
    attrs: {
      "records": _vm.amendedReports,
      "fields": _vm.fields,
      "has-edit": "reports/edit/",
      "has-delete": true,
      "other-buttons": _vm.otherButtons,
      "delete-endpoint": "report/delete"
    },
    on: {
      "modelChange": _vm.fetchTemplates
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-542f07ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reports.vue
// module id = 288
// module chunks = 0